import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from "react-router";
import { NavPaths } from "src/config/routes";
import LoaderWrapper from "./LoaderWrapper";
import React from "react";
const MainApp = React.lazy(() => import("../../MainApp"));
const lazyRetry = (componentImport) => {
    return new Promise((resolve, reject) => {
        componentImport()
            .then((component) => {
            resolve(component);
        })
            .catch((err) => {
            reject(err);
        });
    });
};
const TradingViewChartInIframe = React.lazy(() => import("../../pages/tradingviewchart-in-iframe/tradingviewchart-in-iframe"));
const OptionChainIframe = React.lazy(() => import("../../pages/option-chain/oc-iframe"));
const ExpandedPosition = React.lazy(() => import("src/components/footer/footerPosition/expandedPosition"));
const OptionChainPage = React.lazy(() => lazyRetry(() => import("src/pages/option-chain/option-chain-page")));
const OrdersDashboard = React.lazy(() => import("src/components/footer/footerOrder/ordersDashboard"));
const ExpandedRoutes = () => {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/*", element: LoaderWrapper(_jsx(MainApp, {})) }), _jsx(Route, { path: NavPaths.chainExpanded, element: LoaderWrapper(_jsx(OptionChainPage, {})) }), _jsx(Route, { path: NavPaths.orderbookExpanded, element: LoaderWrapper(_jsx(OrdersDashboard, { onModalClose: function () {
                        throw new Error("Function not implemented.");
                    } })) }), _jsx(Route, { path: NavPaths.positionExpanded, element: LoaderWrapper(_jsx(ExpandedPosition, {})) }), _jsx(Route, { path: NavPaths.Chart, element: LoaderWrapper(_jsx(TradingViewChartInIframe, {})) }), _jsx(Route, { path: NavPaths.optionChainIframe, element: LoaderWrapper(_jsx(OptionChainIframe, {})) })] }));
};
export default ExpandedRoutes;
